import React from 'react';
import { UncontrolledCollapse, ListGroup } from 'reactstrap';

import DependsOnAnswerListItem from './DependsOnAnswerListItem';

const DependsOnAnswersList = props => {

    const { fullWidthStyle, answerGroup } = styles;
    const activeCollapse = Number(props.dependsOnQuestion.id) === Number(props.questionState.dependsOnQuestionId) ? 'collapse show' : 'collapse';

    return (
        <UncontrolledCollapse toggler={props.dependsOnQuestion.id} style={answerGroup} className={activeCollapse}>
            <ListGroup style={fullWidthStyle}>
                {
                    props.dependsOnQuestion.answerDraftDtos.map((answerDraftDto, i) => {

                        return (
                            <DependsOnAnswerListItem key={`deponAnswerKey_${i}`} {...props} answerDraftDto={answerDraftDto} iterator={i} />
                        );
                    })
                }
            </ListGroup>
        </UncontrolledCollapse>
    );
}

export default DependsOnAnswersList;

const styles = {
    fullWidthStyle: {
        width: '100%'
    },
    answerGroup: {
        marginLeft: 25
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/common/dependsOn/DependsOnAnswersList.js